import React from 'react';
import { PriceLine } from '../../services/summaryPriceCalculations';
import PriceLineRow from './PriceLineRow';
import { taxNote } from '../../utils/priceFormat';

interface PriceBreakdownProps {
  priceLines: PriceLine[];
  finalPrice: number;
  showGross: boolean;
  formatPrice: (price: number) => string;
  formatLineAmount: (net: number | null) => string;
  discountCode?: string | null;
  discountAmount?: number;
  onRequestOffer: () => void;
}

function isPriced(line: PriceLine): boolean {
  return line.net != null && line.net > 0;
}

/**
 * Übersichtsansicht der Zusammenfassung: Positionsliste links,
 * Preis-Panel rechts. Das Formular selbst lebt in OfferForm.
 */
export default function PriceBreakdown({
  priceLines,
  finalPrice,
  showGross,
  formatPrice,
  formatLineAmount,
  discountCode,
  discountAmount = 0,
  onRequestOffer,
}: PriceBreakdownProps) {
  return (
    <div className="sv-summary">
      <section className="sv-summary-spec">
        <header className="sv-summary-intro">
          <h2 className="sv-h2 text-ink">Ihr Preis steht fest.</h2>
          <p className="sv-lede mt-3">
            Das ist der Preis Ihrer Konfiguration. Fordern Sie das Angebot
            als PDF per E-Mail an — unverbindlich.
          </p>
        </header>

        <dl className="sv-spec">
          {priceLines.map((line) => (
            <PriceLineRow
              key={line.id}
              label={line.label}
              detail={line.detail}
              amount={
                isPriced(line) ? formatLineAmount(line.net) : 'inklusive'
              }
              included={!isPriced(line)}
            />
          ))}
        </dl>
      </section>

      <aside className="sv-offer-panel">
        <p className="sv-offer-price">{formatPrice(finalPrice)}</p>
        <p className="sv-offer-note">{taxNote(showGross)}</p>

        {discountCode && (
          <div className="mt-4 sv-hairline-t pt-4 flex items-baseline justify-between">
            <span className="text-[16px] text-ink-2">
              Rabatt {discountCode}
            </span>
            <span className="sv-mono text-[16px] text-rubric tabular-nums">
              – {formatPrice(discountAmount)}
            </span>
          </div>
        )}

        <button
          type="button"
          onClick={onRequestOffer}
          className="sv-btn sv-btn-primary mt-8 w-full"
        >
          Unverbindliches Angebot
        </button>
        <p className="sv-offer-cta-hint">
          Sie erhalten das unverbindliche Angebot direkt per E-Mail.
        </p>
      </aside>
    </div>
  );
}
